import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Loading from "components/Loading";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import { useState, useEffect } from "react";
import MDInput from "components/MDInput";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import apiClient from "Api";
import Alert from "@mui/material/Alert";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Link from "@mui/material/Link";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { useAuth } from "hooks/useAuth";
import { useParams } from "react-router-dom";
import Divider from "@mui/material/Divider";
import { Chip } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TimelineList from "examples/Timeline/TimelineList";
import TimelineItem from "examples/Timeline/TimelineItem";

function TenantConfig({ tenantId }) {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [history, setHistory] = useState([]);

  const [formData, setFormData] = useState({
    shopifyDomain: "",
    merchantId: "",
    merchantKey: "",
    pixData: {
      id: "",
      provider: "",
      expirationInSeconds: 86400,
    },
    boletoData: {
      id: "",
      provider: "",
      boletoNumber: "",
      expirationInDays: "",
      assignor: "",
      identification: "",
      demonstrative: "",
      instructions: "",
    },
    creditCardData: {
      id: "",
      provider: "",
      maxInstallments: "",
      minIntallmentValue: "",
    },
    customCreditCardData: {
      id: "",
      provider: "",
      maxInstallments: "",
      minIntallmentValue: "",
    },
    protectedCardData: {
      id: ""
    },
    shopifyDomain: "",
    shopifyShopDomain: "",
    shopifyShopId: 0,
    shopifyShopName: "",
    shopifyShopPhone: "",
    shopifyShopPlanDisplayName: "",
    shopifyShopShopOwner: "",
    shopifyShopEmail: "",
    history: [],
  });

  const getConfig = () => {
    setIsLoading(true);
    return apiClient
      .get(`/admin/tenants/${tenantId}`)
      .then((response) => {
        setFormData(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar("Erro ao retornar dados da loja!", {
          variant: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const isValid = (value) => {
    var ret = value && value.toString().trim() !== "";

    return ret === true;
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    let historyArray = [];
    {
      formData.history?.map((item, index, array) => {
        var metadata = null;

        if (item.metadata != "null" && item.metadata != null) {
          var metadataJson = JSON.parse(item.metadata);
          metadata = (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                Metadata
              </AccordionSummary>
              <AccordionDetails>
                <pre style={{ overflow: "scroll" }}>
                  {JSON.stringify(metadataJson, null, 2)}
                </pre>
              </AccordionDetails>
            </Accordion>
          );
        }

        var error = null;

        if (item.error !== null) {
          error = (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                Error
              </AccordionSummary>
              <AccordionDetails>
                <pre style={{ overflow: "scroll" }}>{item.error}</pre>
              </AccordionDetails>
            </Accordion>
          );
        }

        historyArray.push(
          <TimelineItem
            key={index + " - " + item.type}
            color={item.isSuccess ? "success" : "error"}
            icon={item.isSuccess ? "done" : "priority_high"}
            title={item.type}
            dateTime={new Date(item.createdAt).toLocaleString()}
            description={
              <>
                <p>{item.type}</p>
                {metadata}
                {error}
              </>
            }
            lastItem={index === array.length - 1}
          />
        );
      });
    }

    setHistory(historyArray);
  }, [formData]);

  return (
    <Grid container>
      <Loading isLoading={isLoading}></Loading>
      <Grid item xs={12}>
        <Card>
          <MDBox p={4}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} mb={2}>
                <MDTypography variant="h6">Dados da loja</MDTypography>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <MDInput
                  type="text"
                  label="Shopify Domain"
                  fullWidth
                  value={formData.shopifyDomain}
                  onChange={(e) =>
                    setFormData({ ...formData, merchantId: e.target.value })
                  }
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MDInput
                  type="text"
                  label="MerchantId"
                  fullWidth
                  value={formData.merchantId}
                  onChange={(e) =>
                    setFormData({ ...formData, merchantId: e.target.value })
                  }
                  required
                  error={!isValid(formData.merchantId)}
                  success={isValid(formData.merchantId)}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MDInput
                  type="text"
                  label="MerchantKey"
                  fullWidth
                  value={formData.merchantKey}
                  onChange={(e) =>
                    setFormData({ ...formData, merchantKey: e.target.value })
                  }
                  required
                  error={!isValid(formData.merchantKey)}
                  success={isValid(formData.merchantKey)}
                  disabled
                />
              </Grid>

              {formData.shopifyShopEmail && (
                <>
                  <Grid item xs={12} sm={12} md={4}>
                    <MDInput
                      type="text"
                      label="Nome Owner"
                      fullWidth
                      value={formData.shopifyShopShopOwner}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          shopifyShopShopOwner: e.target.value,
                        })
                      }
                      required
                      error={!isValid(formData.shopifyShopShopOwner)}
                      success={isValid(formData.shopifyShopShopOwner)}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <MDInput
                      type="text"
                      label="E-mail"
                      fullWidth
                      value={formData.shopifyShopEmail}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          shopifyShopEmail: e.target.value,
                        })
                      }
                      required
                      error={!isValid(formData.shopifyShopEmail)}
                      success={isValid(formData.shopifyShopEmail)}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <MDInput
                      type="text"
                      label="Telefone"
                      fullWidth
                      value={formData.shopifyShopPhone ?? ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          shopifyShopPhone: e.target.value,
                        })
                      }
                      required
                      error={!isValid(formData.shopifyShopPhone ?? "")}
                      success={isValid(formData.shopifyShopPhone ?? "")}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <MDInput
                      type="text"
                      label="Shop Name"
                      fullWidth
                      value={formData.shopifyShopName}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          shopifyShopName: e.target.value,
                        })
                      }
                      required
                      error={!isValid(formData.shopifyShopName)}
                      success={isValid(formData.shopifyShopName)}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <MDInput
                      type="text"
                      label="Domínio"
                      fullWidth
                      value={formData.shopifyShopDomain}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          shopifyShopDomain: e.target.value,
                        })
                      }
                      required
                      error={!isValid(formData.shopifyShopDomain)}
                      success={isValid(formData.shopifyShopDomain)}
                      disabled
                    />
                  </Grid>
                </>
              )}
            </Grid>

            {formData.pixData != null && isValid(formData.pixData?.id) && (
              <>
                <Divider />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} mb={2}>
                    <MDTypography variant="h6">Pix</MDTypography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Status"
                      value={formData.pixData.status ?? ""}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Data instalação"
                      value={
                        formData.pixData.installDate
                          ? new Date(
                            formData.pixData.installDate
                          ).toLocaleString()
                          : ""
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Data desinstalação"
                      value={
                        formData.pixData.uninstallDate
                          ? new Date(
                            formData.pixData.uninstallDate
                          ).toLocaleString()
                          : ""
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      label="Provider"
                      value={formData.pixData.provider ?? ""}
                      error={!isValid(formData.pixData.provider)}
                      success={isValid(formData.pixData.provider)}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="number"
                      label="Tempo expiração e segundos"
                      value={formData.pixData.expirationInSeconds ?? ""}
                      error={!isValid(formData.pixData.expirationInSeconds)}
                      success={isValid(formData.pixData.expirationInSeconds)}
                      fullWidth
                      disabled
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {formData.boletoData != null && isValid(formData.boletoData.id) && (
              <>
                <Divider />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} mb={2}>
                    <MDTypography variant="h6">Boleto</MDTypography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Status"
                      value={formData.boletoData.status ?? ""}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Data instalação"
                      value={
                        formData.boletoData.installDate
                          ? new Date(
                            formData.boletoData.installDate
                          ).toLocaleString()
                          : ""
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Data desinstalação"
                      value={
                        formData.boletoData.uninstallDate
                          ? new Date(
                            formData.boletoData.uninstallDate
                          ).toLocaleString()
                          : ""
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Provider"
                      value={formData.boletoData.provider ?? ""}
                      error={!isValid(formData.boletoData.provider)}
                      success={isValid(formData.boletoData.provider)}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="text"
                      label="Nosso Número"
                      fullWidth
                      value={formData.boletoData.boletoNumber ?? ""}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput
                      type="number"
                      label="Dias para vencimento"
                      fullWidth
                      value={formData.boletoData.expirationInDays ?? ""}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      label="Nome do cedente"
                      fullWidth
                      value={formData.boletoData.assignor ?? ""}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      label="CNPJ do Cedente"
                      fullWidth
                      value={formData.boletoData.identification ?? ""}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput
                      type="text"
                      multiline
                      rows={3}
                      label="Texto de demonstrativo"
                      fullWidth
                      value={formData.boletoData.demonstrative ?? ""}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput
                      type="text"
                      multiline
                      rows={3}
                      label="Instruções do boleto"
                      fullWidth
                      value={formData.boletoData.instructions ?? ""}
                      disabled
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {formData.creditCardData != null &&
              isValid(formData.creditCardData.id) && (
                <>
                  <Divider />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} mb={2}>
                      <MDTypography variant="h6">
                        Cartão de crédito
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Status"
                        value={formData.creditCardData.status ?? ""}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Data instalação"
                        value={
                          formData.creditCardData.installDate
                            ? new Date(
                              formData.creditCardData.installDate
                            ).toLocaleString()
                            : ""
                        }
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Data desinstalação"
                        value={
                          formData.creditCardData.uninstallDate
                            ? new Date(
                              formData.creditCardData.uninstallDate
                            ).toLocaleString()
                            : ""
                        }
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Provider"
                        value={formData.creditCardData.provider ?? ""}
                        error={!isValid(formData.creditCardData.provider)}
                        success={isValid(formData.creditCardData.provider)}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="number"
                        label="Número máximo de parcelas"
                        fullWidth
                        value={formData.creditCardData.maxInstallments ?? ""}
                        disabled
                        error={
                          !isValid(formData.creditCardData.maxInstallments)
                        }
                        success={isValid(
                          formData.creditCardData.maxInstallments
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="number"
                        label="Valor mínimo das parcelas"
                        fullWidth
                        value={formData.creditCardData.minIntallmentValue ?? ""}
                        disabled
                        error={
                          !isValid(formData.creditCardData.minIntallmentValue)
                        }
                        success={isValid(
                          formData.creditCardData.minIntallmentValue
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Verify Card Habilitado"
                        fullWidth
                        value={formData.creditCardData.verifyCardEnabled ?? false}
                        disabled
                        error={
                          !isValid(formData.creditCardData.verifyCardEnabled)
                        }
                        success={isValid(
                          formData.creditCardData.verifyCardEnabled
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Verify Card: Prosseguir caso inconclusivo"
                        fullWidth
                        value={formData.creditCardData.verifyCardProceedOnInconclusive ?? ""}
                        disabled
                        error={
                          !isValid(formData.creditCardData.verifyCardProceedOnInconclusive)
                        }
                        success={isValid(
                          formData.creditCardData.verifyCardProceedOnInconclusive
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Retentativa Habilitada"
                        fullWidth
                        value={formData.creditCardData?.RetriesEnabled ?? false}
                        disabled
                        error={
                          !isValid(formData.creditCardData?.RetriesEnabled)
                        }
                        success={isValid(
                          formData.creditCardData?.RetriesEnabled
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Retentativa Provider"
                        fullWidth
                        value={formData.creditCardData.RetriesProvider ?? ""}
                        disabled
                        error={
                          !isValid(formData.creditCardData?.RetriesProvider)
                        }
                        success={isValid(
                          formData.creditCardData?.RetriesProvider
                        )}
                        required
                      />
                    </Grid>

                    {formData.creditCardData.fraudAnalysisEnabled && (
                      <>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Provider análise de risco"
                            fullWidth
                            value={
                              formData.creditCardData.fraudAnalysisProvider ??
                              ""
                            }
                            disabled
                            error={
                              !isValid(
                                formData.creditCardData.fraudAnalysisProvider
                              )
                            }
                            success={isValid(
                              formData.creditCardData.fraudAnalysisProvider
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Sequência análise de risco"
                            fullWidth
                            value={
                              formData.creditCardData.fraudAnalysisSequence ??
                              ""
                            }
                            disabled
                            error={
                              !isValid(
                                formData.creditCardData.fraudAnalysisSequence
                              )
                            }
                            success={isValid(
                              formData.creditCardData.fraudAnalysisSequence
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Critério análise de risco"
                            fullWidth
                            value={
                              formData.creditCardData
                                .fraudAnalysisSequenceCriteria ?? ""
                            }
                            disabled
                            error={
                              !isValid(
                                formData.creditCardData
                                  .fraudAnalysisSequenceCriteria
                              )
                            }
                            success={isValid(
                              formData.creditCardData
                                .fraudAnalysisSequenceCriteria
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Capturar com baixo risco"
                            fullWidth
                            value={
                              formData.creditCardData
                                .fraudAnalysisCaptureOnLowRisk ?? ""
                            }
                            disabled
                            success={isValid(
                              formData.creditCardData
                                .fraudAnalysisCaptureOnLowRisk
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Cancelar com alto risco"
                            fullWidth
                            value={
                              formData.creditCardData
                                .fraudAnalysisVoidOnHighRisk ?? ""
                            }
                            disabled
                            success={isValid(
                              formData.creditCardData
                                .fraudAnalysisVoidOnHighRisk
                            )}
                          />
                        </Grid>
                      </>
                    )}

                  </Grid>
                </>
              )}

            {formData.customCreditCardData != null &&
              isValid(formData.customCreditCardData.id) && (
                <>
                  <Divider />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} mb={2}>
                      <MDTypography variant="h6">
                        Cartão de crédito(Custom)
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Status"
                        value={formData.customCreditCardData.status ?? ""}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Data instalação"
                        value={
                          formData.customCreditCardData.installDate
                            ? new Date(
                              formData.customCreditCardData.installDate
                            ).toLocaleString()
                            : ""
                        }
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Data desinstalação"
                        value={
                          formData.customCreditCardData.uninstallDate
                            ? new Date(
                              formData.customCreditCardData.uninstallDate
                            ).toLocaleString()
                            : ""
                        }
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Provider"
                        value={formData.customCreditCardData.provider ?? ""}
                        error={!isValid(formData.customCreditCardData.provider)}
                        success={isValid(formData.customCreditCardData.provider)}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="number"
                        label="Número máximo de parcelas"
                        fullWidth
                        value={formData.customCreditCardData.maxInstallments ?? ""}
                        disabled
                        error={
                          !isValid(formData.customCreditCardData.maxInstallments)
                        }
                        success={isValid(
                          formData.customCreditCardData.maxInstallments
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="number"
                        label="Valor mínimo das parcelas"
                        fullWidth
                        value={formData.customCreditCardData.minIntallmentValue ?? ""}
                        disabled
                        error={
                          !isValid(formData.customCreditCardData.minIntallmentValue)
                        }
                        success={isValid(
                          formData.customCreditCardData.minIntallmentValue
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Verify Card Habilitado"
                        fullWidth
                        value={formData.customCreditCardData.verifyCardEnabled ?? false}
                        disabled
                        error={
                          !isValid(formData.customCreditCardData.verifyCardEnabled)
                        }
                        success={isValid(
                          formData.customCreditCardData.verifyCardEnabled
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Verify Card: Prosseguir caso inconclusivo"
                        fullWidth
                        value={formData.customCreditCardData.verifyCardProceedOnInconclusive ?? ""}
                        disabled
                        error={
                          !isValid(formData.customCreditCardData.verifyCardProceedOnInconclusive)
                        }
                        success={isValid(
                          formData.customCreditCardData.verifyCardProceedOnInconclusive
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Retentativa Habilitada"
                        fullWidth
                        value={formData.customCreditCardData?.RetriesEnabled ?? false}
                        disabled
                        error={
                          !isValid(formData.customCreditCardData?.RetriesEnabled)
                        }
                        success={isValid(
                          formData.customCreditCardData?.RetriesEnabled
                        )}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Retentativa Provider"
                        fullWidth
                        value={formData.customCreditCardData.RetriesProvider ?? ""}
                        disabled
                        error={
                          !isValid(formData.customCreditCardData?.RetriesProvider)
                        }
                        success={isValid(
                          formData.customCreditCardData?.RetriesProvider
                        )}
                        required
                      />
                    </Grid>

                    {formData.customCreditCardData.fraudAnalysisEnabled && (
                      <>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Provider análise de risco"
                            fullWidth
                            value={
                              formData.customCreditCardData.fraudAnalysisProvider ??
                              ""
                            }
                            disabled
                            error={
                              !isValid(
                                formData.customCreditCardData.fraudAnalysisProvider
                              )
                            }
                            success={isValid(
                              formData.customCreditCardData.fraudAnalysisProvider
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Sequência análise de risco"
                            fullWidth
                            value={
                              formData.customCreditCardData.fraudAnalysisSequence ??
                              ""
                            }
                            disabled
                            error={
                              !isValid(
                                formData.customCreditCardData.fraudAnalysisSequence
                              )
                            }
                            success={isValid(
                              formData.customCreditCardData.fraudAnalysisSequence
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Critério análise de risco"
                            fullWidth
                            value={
                              formData.customCreditCardData
                                .fraudAnalysisSequenceCriteria ?? ""
                            }
                            disabled
                            error={
                              !isValid(
                                formData.customCreditCardData
                                  .fraudAnalysisSequenceCriteria
                              )
                            }
                            success={isValid(
                              formData.customCreditCardData
                                .fraudAnalysisSequenceCriteria
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Capturar com baixo risco"
                            fullWidth
                            value={
                              formData.customCreditCardData
                                .fraudAnalysisCaptureOnLowRisk ?? ""
                            }
                            disabled
                            success={isValid(
                              formData.customCreditCardData
                                .fraudAnalysisCaptureOnLowRisk
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDInput
                            type="text"
                            label="Cancelar com alto risco"
                            fullWidth
                            value={
                              formData.customCreditCardData
                                .fraudAnalysisVoidOnHighRisk ?? ""
                            }
                            disabled
                            success={isValid(
                              formData.customCreditCardData
                                .fraudAnalysisVoidOnHighRisk
                            )}
                          />
                        </Grid>
                      </>
                    )}

                  </Grid>
                </>
              )}

            {formData.protectedCardData != null &&
              isValid(formData.protectedCardData.id) && (
                <>
                  <Divider />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} mb={2}>
                      <MDTypography variant="h6">
                        ProtectedCard(Custom)
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Status"
                        value={formData.protectedCardData.status ?? ""}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Data instalação"
                        value={
                          formData.protectedCardData.installDate
                            ? new Date(
                              formData.protectedCardData.installDate
                            ).toLocaleString()
                            : ""
                        }
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDInput
                        type="text"
                        label="Data desinstalação"
                        value={
                          formData.protectedCardData.uninstallDate
                            ? new Date(
                              formData.protectedCardData.uninstallDate
                            ).toLocaleString()
                            : ""
                        }
                        fullWidth
                        disabled
                      />
                    </Grid>
                  </Grid>
                </>
              )}

            {history?.length > 0 && (
              <>
                <Divider />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <TimelineList title="Histórico">{history}</TimelineList>
                  </Grid>
                </Grid>
              </>
            )}
          </MDBox>
        </Card>
      </Grid>
    </Grid>
  );
}

TenantConfig.propTypes = {
  tenantId: PropTypes.string,
};

export default TenantConfig;
